(function($) {
      
  $(document).ready(function() {
    const scrollToTopBtn = document.getElementById('infinatorSTP');
    if ( ! scrollToTopBtn) return false;
    function showScrollToTopBtn() {
      scrollToTopBtn.style.transform = 'unset';
	  }

    function hideScrollToTopBtn() {
		scrollToTopBtn.style.transform =
			'translateX(8rem) rotate(360deg)';
	  }

    const clickEvent = () => {
      window.removeEventListener('scroll', scrollEvent);
      window.scrollTo({
          top: 0,
          behavior: 'smooth',
      });
      hideScrollToTopBtn();
      setTimeout(() => {
          window.addEventListener('scroll', scrollEvent);
      }, 2000);
    };
    if(scrollToTopBtn)
      scrollToTopBtn.addEventListener('click', clickEvent);
    
    const scrollEvent = () => {
      if (window.scrollY < 200) {
        hideScrollToTopBtn();
        return;
      }
      // window.removeEventListener('scroll', scrollEvent);
      showScrollToTopBtn();
    }
    window.addEventListener('scroll', scrollEvent);
  })
  
})(window.jQuery)